import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import TallasCreate from "./TallasCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";

import Swal from "sweetalert2";
import ExportJsonExcel from "js-export-excel";

function ListadoTallas() {
  const { user } = useContext(AuthContext);
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const [tallas, setTallas] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [order, setOrder] = useState(1);
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);
  const [draggedItem, setDraggedItem] = useState(null);

  const [idEdit, setIdEdit] = useState();

  useEffect(() => {
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTallas = response.data;
        // Sort by order field, fallback to name if order doesn't exist
        allTallas.sort((a, b) => {
          if (a.order !== undefined && b.order !== undefined) {
            return a.order - b.order;
          }
          return a.name > b.name ? 1 : -1;
        });
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function excel() {
    const dataExcel = tallas.map((a) => {
      return {
        ID: a._id,
        nombre: a.name,
        orden: a.order || 0,
      };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};
    option.fileName = "ListadoTallas";
    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoTallas",
        sheetFilter: ["ID", "nombre", "orden"],
        sheetHeader: ["ID", "nombre", "orden"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function editTalla(event) {
    event.preventDefault();
    const URL_TALLAS_EDIT = `${import.meta.env.VITE_URL_TALLAS}/${idEdit}`;
    axios
      .patch(
        URL_TALLAS_EDIT,
        {
          name,
          order
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Talla",
            detalle: `${name} - Orden: ${order}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name, currentOrder) {
    setName(name);
    setOrder(currentOrder || 1);
    setIdEdit(idEdit);
    toggle();
  }

  // Drag and Drop functions
  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    
    if (draggedItem === null || draggedItem === dropIndex) return;

    const newTallas = [...tallas];
    const draggedItemData = newTallas[draggedItem];
    
    // Remove dragged item
    newTallas.splice(draggedItem, 1);
    
    // Insert at new position
    const actualDropIndex = draggedItem < dropIndex ? dropIndex - 1 : dropIndex;
    newTallas.splice(actualDropIndex, 0, draggedItemData);

    // Update orders
    const updatedTallas = newTallas.map((talla, index) => ({
      ...talla,
      order: index + 1
    }));

    setTallas(updatedTallas);
    setDraggedItem(null);

    // Save the new order to backend
    saveNewOrder(updatedTallas);
  };

  const saveNewOrder = async (updatedTallas) => {
    try {
      const promises = updatedTallas.map((talla, index) => 
        axios.patch(
          `${URL_TALLAS}/${talla._id}`,
          { order: index + 1 },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      );

      await Promise.all(promises);
      
      // Log the reorder action
      axios.post(
        URL_LOGS,
        {
          tipo: "Reordenar Tallas",
          detalle: "Orden actualizado mediante drag & drop",
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Orden actualizado",
        text: "El orden de las tallas se ha guardado correctamente",
        timer: 2000,
        showConfirmButton: false
      });

    } catch (error) {
      console.error("Error saving order:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo guardar el nuevo orden",
      });
      // Reload to restore original order
      window.location.reload();
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        {user.menu_articulos ? (
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h3 align="center">Tallas</h3>
                  <p className="text-muted text-center small mb-3">
                    <i className="fas fa-arrows-alt"></i> Arrastra las filas para reordenar
                  </p>
                  
                  <Table
                    size="sm"
                    striped
                    borderless
                    className="table-responsive-xl"
                  >
                    <thead>
                      <tr>
                        <th className="tituloTabla">Orden</th>
                        <th className="tituloTabla">Nombre</th>
                        <th className="tituloTabla">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tallas.map((a, index) => (
                        <tr
                          key={a._id}
                          draggable
                          onDragStart={(e) => handleDragStart(e, index)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, index)}
                          style={{
                            cursor: "move",
                            opacity: draggedItem === index ? 0.5 : 1,
                            backgroundColor: draggedItem === index ? "#f8f9fa" : "transparent"
                          }}
                        >
                          <td>
                            <span className="badge badge-secondary">
                              {a.order || index + 1}
                            </span>
                          </td>
                          <td>{a.name}</td>
                          <td>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaInfo(a._id, a.name, a.order)}
                            >
                              <i className="far fa-edit"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <TallasCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Talla</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12 mb-3"
            type="text"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
          
          <Label className="mr-sm-2">Orden</Label>
          <Input
            className="col-sm-12"
            type="number"
            value={order}
            min="1"
            required
            onChange={(e) => setOrder(parseInt(e.target.value))}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editTalla}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoTallas;